import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';

export const RoundButton = ({ round, currentRoundNumber, onClick }) => {
    const nav = useSelector(navSelector);
    const isActive = Number(nav.round.id) === round.id;

    let roundNumber;

    if (round.abbreviation.includes('Rd')) {
        roundNumber = round.roundNumber;
    } else {
        roundNumber = round.abbreviation;
    }

    return (
        <li
            className={`competition-nav__round-list-item ${
                isActive ? 'is-active' : ''
            } ${
                round.roundNumber === currentRoundNumber
                    ? 'competition-nav__round-list-item--current-round'
                    : ''
            } ${
                round.roundNumber > currentRoundNumber
                    ? 'competition-nav__round-list-item--future-round'
                    : ''
            }`}
        >
            <button
                className="competition-nav__round-list-button"
                onClick={(event) => onClick(event, round)}
            >
                {roundNumber}
            </button>
        </li>
    );
};

RoundButton.propTypes = {
    round: PropTypes.object,
    currentRoundNumber: PropTypes.number,
    onClick: PropTypes.func
};
